import React from "react";

import { templates } from "@reactivated";

import { StickyConfiguratorSSR } from "../apps/configurator/StickyConfiguratorSSR";

// This template is imported by @reactivated generated types.
// Sites override this with their own implementations in client/templates/StickyConfiguratorTemplate.tsx
/** @public */
export const Template = (
    props: templates.StickyConfiguratorTemplate,
): React.JSX.Element => {
    return <StickyConfiguratorSSR {...props} />;
};
